import { ProjectPartShortInfoCtrl } from './project.part.short.info.controller';
import template from './project.part.short.info.html';

export const projectPartShortInfo: angular.IDirectiveFactory = () => ({
  bindToController: true,
  controller: ProjectPartShortInfoCtrl,
  controllerAs: 'vm',
  template,
  restrict: 'AE',
  scope: {
    isActive: '=',
    projectPartData: '=',
    hideShortInfo: '&',
    showPartPopup: '&',
  },
});
